<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：菜品分类-添加
    -->
  <el-dialog :visible.sync="dialogVisible" width="40%" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <template v-slot:title>
      <div>
        <span style="font-size: 18px;margin-right: 5px">{{$t('添加类型')}}</span>
        <span class="form-item-hint"><i class="el-icon-info"></i>{{$t('设置桌位类型，如二人桌、四人桌、大桌、小桌等')}}</span>
      </div>
    </template>
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item :label="$t('类型名称')" prop="type_name" :label-width="formLabelWidth">
        <el-input v-model="form.type_name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('最少人数')" prop="min_num" :label-width="formLabelWidth">
        <el-input v-model.number="form.min_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('最多人数')" prop="max_num" :label-width="formLabelWidth">
        <el-input v-model.number="form.max_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('排序')" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">{{$t('取 消')}}</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">{{$t('确 定')}}</el-button>
    </div>
  </el-dialog>

</template>

<script>
  import StoreApi from '@/api/store.js';
  export default {
    components: {},
    data() {
      return {
        form: {
          type_name: '',
          min_num:1,
          max_num:1,
          sort: 100,
        },
        formRules: {
          type_name: [{
            required: true,
            message: this.$t('请输入类型名称'),
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: this.$t('排序不能为空')
          }, {
            type: 'number',
            message: this.$t('排序必须为数字')
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_add', 'addform'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加用户*/
      addUser() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.addType(params).then(data => {
              self.loading = false;
              self.$message({
                message: self.$t('添加成功'),
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/buildStore/type/add.vue